module.exports = __webpack_public_path__ + "img/new_shanghai_2.618bead8.jpg";